




















import { Component, Prop, Vue } from 'vue-property-decorator';
import MpCard from '@/components/controls/mp-card/MpCard.vue';
import { KeyValuePair } from '@/connectors/kvp.model';
@Component({
  components: { MpCard }
})
export default class MpShowRatingCountsCard extends Vue {
  @Prop()
  height!: string;

  @Prop({ default: 'Detailansicht der Bewertung' })
  title!: string;

  @Prop()
  value!: Array<KeyValuePair<number, number>>;

  get sortedValue() {
    return this.value.sort((a, b) => {
      return b.key - a.key;
    });
  }

  get hasNoValues(): boolean {
    return this.value.every(kvp => !kvp.value);
  }

  calculateRatingPercentage(stats: Array<KeyValuePair<number, number>>, target: number): number {
    let sumAll = 0;
    let sumFromTarget = 0;
    const targetKvP = stats.find(s => s.key === target);

    if (!!targetKvP) {
      sumFromTarget = targetKvP.value;
    }

    stats.forEach(s => (sumAll += s.value));

    if (sumFromTarget === 0 || sumAll === 0) {
      return 0;
    }

    return (sumFromTarget / sumAll) * 100;
  }
}
